// extracted by mini-css-extract-plugin
module.exports = {"details":"IndicatorsDetails_details__2VnNF"};